import { createFileRoute } from '@tanstack/react-router';

import { queryCountry } from 'src/api/queries';
import { WinbackOfferCheckoutPage } from 'src/apps/checkout/app/pages/WinbackOffer.Checkout';

export const Route = createFileRoute(
  '/_auth/_only-header/store/methods-offer/_allowed/checkout'
)({
  loader: async ({ context }) =>
    context.queryClient.ensureQueryData(queryCountry()),
  component: () => <WinbackOfferCheckoutPage />,
});
